import { useTranslation } from "react-i18next";
import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { CircularProgressBar } from "../ProgressBar/Circular";
import type { OverallProgress } from "./types";

type Props = {
	progress: OverallProgress;
};

export const OverallProgressCard = ({ progress }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const clampedPercent = Math.min(Math.max(progress.percent, 0), 100);

	return (
		<Card
			mode="outlined"
			style={{
				borderRadius: theme.roundness * 3,
				borderColor: theme.colors.outlineVariant,
			}}
		>
			<Card.Content style={{ paddingHorizontal: 16, paddingVertical: 16 }}>
				<Box flexDirection="row" alignItems="center" gap={12}>
					<Box position="relative" width={50} height={50}>
						<CircularProgressBar
							progress={clampedPercent / 100}
							size="mediumAlt"
							strokeWidth={4}
						/>
						<Box
							position="absolute"
							top={0}
							right={0}
							bottom={0}
							left={0}
							alignItems="center"
							justifyContent="center"
						>
							<Text
								variant="labelMedium"
								style={{ color: theme.colors.primary }}
							>
								{`${Math.round(clampedPercent)}%`}
							</Text>
						</Box>
					</Box>
					<Box gap={2}>
						<Text variant="bodyLarge">
							{t("lessons.stats.overallProgress.title")}
						</Text>
						<Text
							variant="bodyMedium"
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{t("lessons.stats.overallProgress.completedCount", {
								completed: progress.completedCount,
								count: progress.totalCount,
							})}
						</Text>
					</Box>
				</Box>
			</Card.Content>
		</Card>
	);
};
